import { ensureCurrentUser, ensurePaymentMethodCard, ensureStripeCustomer } from './data';

export const getUserSubscriptionStatus = user => {
  if (!user) return null;
  return user.attributes?.profile?.privateData?.subscriptionData?.status;
};
export const getUserSubscriptionPlanId = user => {
  if (!user) return null;
  return user.attributes?.profile?.privateData?.subscriptionData?.planDetails?.id;
};

export const getUserType = user => {
  if (!user?.id) return null;
  return user?.attributes?.profile?.publicData?.userType || 'Unknown';
};

export const getUserDetails = user => {
  if (!user?.id) return null;

  const defaultProfile = { firstName: '', lastName: '', email: '' };
  const { firstName = '', lastName = '', publicData = {}, protectedData = {} } =
    user?.attributes?.profile || defaultProfile;
  const email = user?.attributes?.email || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const { phoneNumber, dateOfBirth } = protectedData || {};
  return {
    firstName,
    lastName,
    email,
    phoneNumber,
    dateOfBirth,
    fullName,
  };
};

export const getDefaultPaymentMethod = user => {
  const hasDefaultPaymentMethod =
    user?.id &&
    ensureStripeCustomer(user.stripeCustomer).attributes.stripeCustomerId &&
    ensurePaymentMethodCard(user.stripeCustomer.defaultPaymentMethod).id;
  return hasDefaultPaymentMethod ?? null;
};

export function getClientSecret(setupIntent) {
  return setupIntent && setupIntent.attributes ? setupIntent.attributes.clientSecret : null;
}

export function getPaymentParams(currentUser, formValues) {
  const { name, addressLine1, addressLine2, postal, state, city, country } = formValues;

  const addressMaybe =
    addressLine1 && postal
      ? {
          address: {
            city: city,
            country: country,
            line1: addressLine1,
            line2: addressLine2,
            postal_code: postal,
            state: state,
          },
        }
      : {};


  const billingDetails = {
    name,
    email: ensureCurrentUser(currentUser).attributes.email,
    ...addressMaybe,
  };


  const paymentParams = {
    payment_method_data: {
      billing_details: billingDetails,
    },
  };
  return paymentParams;
}
